import imageCompression from 'browser-image-compression';

const MAX_DIMENSION = 1280;
const IMAGE_TYPES = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];

/**
 * Compress image if either dimension exceeds 1280px
 * Uses browser-image-compression library with Web Workers for performance.
 *
 * @param file - File to compress
 * @returns Compressed file (or original if not an image or already small enough)
 */
export async function compressImageIfNeeded(file: File): Promise<File> {
  // Skip non-image files
  if (!IMAGE_TYPES.includes(file.type)) {
    return file;
  }

  const options = {
    maxWidthOrHeight: MAX_DIMENSION,
    useWebWorker: true,
    preserveExif: true,
  };

  try {
    const compressedBlob = await imageCompression(file, options);

    // Preserve original filename (library may return blob without proper name)
    const compressedFile = new File([compressedBlob], file.name, {
      type: compressedBlob.type,
      lastModified: Date.now(),
    });

    // Log compression result for debugging
    if (compressedFile.size < file.size) {
      console.log(
        `Image compressed: ${(file.size / 1024 / 1024).toFixed(2)}MB → ${(compressedFile.size / 1024 / 1024).toFixed(2)}MB`
      );
    }

    return compressedFile;
  } catch (error) {
    console.error('Image compression failed, using original:', error);
    return file; // Fallback to original on error
  }
}
